/**
 * A fraction, for representing values that may not be accurately representable
 * as floating point numbers.
 *
 * Reference: https://en.wikipedia.org/wiki/Fraction
 */
export interface Fraction {
  readonly numerator: number;
  readonly denominator: number;
}


export const FRAC_ZERO: Fraction = {
  numerator: 0,
  denominator: 1,
};


export function isInstanceOfFraction(obj: unknown): obj is Fraction {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  const fraction = obj as Partial<Fraction>;
  return typeof fraction.numerator === 'number' &&
    typeof fraction.denominator === 'number';
}
